/** Small version of the white play overlay used in the post table and composer preview. */
export const VideoPlayBadge = () => (
  <span
    aria-hidden="true"
    className="flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full bg-white/90 shadow-sm"
  >
    <span className="ml-0.5 h-0 w-0 border-t-[6px] border-b-[6px] border-l-[9px] border-t-transparent border-b-transparent border-l-gray-800" />
  </span>
);
